import { Component, h, Host, Element, Prop, State } from '@stencil/core';

@Component({
  tag: 'wdf-search-button',
  shadow: false,
})
export class SearchButton {
  @Element() el!: HTMLElement;

  @Prop() isOpen: boolean;
  @Prop() url: string;
  @Prop() placeholder: string;

  @State() booleanIsOpen: boolean;
  @State() inputValue: string;

  componentDidLoad() {
    this.updateInputValue();
  }

  private toggleSearchButton = (e: Event) => {
    const inputElement = this.el.querySelector<HTMLInputElement>('input[data-input="search-input"]');
    this.booleanIsOpen = !this.booleanIsOpen;
    e.preventDefault();

    if (this.booleanIsOpen) {
      inputElement?.focus();
    }

    this.updateInputValue();
  };

  private handleInput = () => {
    this.updateInputValue();
  };

  handleSubmit = (e: Event) => {
    e.preventDefault();
  
    // Clean and trim the input value
    if (this.inputValue) {
      this.inputValue = decodeURIComponent(this.inputValue.replace(/"/g, '')).trim();
    }
  
    if (this.url && this.inputValue) {
      window.location.href = `${this.url}?query=${encodeURIComponent(this.inputValue)}`;
    } else {
      window.location.href = `${this.url}`;
    }
  };

  private updateInputValue() {
    const inputElement = this.el.querySelector<HTMLInputElement>('input[data-input="search-input"]');
    this.inputValue = inputElement?.value || '';

    const searchIcon = this.el.querySelector<HTMLElement>('use[data-icon="search"]');
    searchIcon?.classList.toggle('stroke-silver', this.inputValue.length === 0);
    searchIcon?.classList.toggle('stroke-gray', this.inputValue.length > 0);
  }

  render() {
    return (
      <Host class="block">
        <div class="relative">
          <form id="search" class="flex group justify-end relative" onSubmit={this.handleSubmit}>
            <label htmlFor="search-input" class="sr-only">
              Search this site
            </label>
            <div class="relative">
              <button tabindex="-1" aria-label="toggle-search" class={`search-toggle-btn px-16 py-14 absolute rounded-full ${this.booleanIsOpen ? 'white' : 'gray'}`}>
                <svg class="h-14 w-14">
                  <use class={`${this.booleanIsOpen ? '' : 'opacity-0 delay-0'} transition-all`} xlinkHref='/assets/spritemap.svg#search' data-icon="search"></use>
                </svg>
              </button>
            </div>
            <input tabindex="-1"
              placeholder={`${this.placeholder}`}
              type="search"
              id="search-input"
              data-input="search-input"
              class={`search-btn w-full box-border py-10 px-[22px] rounded-full outline-1 border appearance-none focus-within:outline-none outline-none focus-within:border-gray ${this.booleanIsOpen ? 'open pl-64' : 'closed'}`}
              name="search"
              spellcheck="false"
              value={this.inputValue}
              onInput={this.handleInput}
            />
          </form>
          <button onClick={this.toggleSearchButton} aria-label={!this.booleanIsOpen ? `Open search` : `Close search`} class="close-btn px-16 py-14 absolute rounded-full right-0 top-0 " data-button="toggle-button">
            <svg class={`h-14 w-14 text-gray`}>
              <use class={`${this.booleanIsOpen ? 'stroke-gray' : 'stroke-white'}`} xlinkHref={`${this.booleanIsOpen ? '/assets/spritemap.svg#x' : '/assets/spritemap.svg#search'}`} />
            </svg>
          </button>
        </div>
      </Host>
    );
  }
}